module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card container",
    staticStyle: {
      "height": "90%",
      "border": "0px solid #000000",
      "padding": "12px",
      "border-radius": "12px",
      "margin": "auto",
      "background": "#FFFFFF"
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    attrs: {
      "for": "section"
    }
  }, [_vm._v("Select Data Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upload_section),
      expression: "upload_section"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "section"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.upload_section = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.uploadSections), function(section) {
    return _c('option', {
      key: section
    }, [_vm._v(_vm._s(section))])
  }))]), _vm._v(" "), (this.hasUpload) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit),
      expression: "edit"
    }],
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "filename"
    }
  }, [_vm._v("File:  ")]), _c('span', {
    attrs: {
      "name": "filename"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("  " + _vm._s(_vm.filename))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('label', [_vm._v("Summary:  ")]), _vm._v(" "), (this.showWarning) ? _c('div', [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "width": "30px;"
    }
  }, [_vm._v(_vm._s(_vm.locations.length))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Data Rows")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.found_optional_headers.length))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', [_vm._v("Optional Headers")]), _vm._v(" "), _c('td', [_c('select', {
    staticStyle: {
      "width": "150px"
    }
  }, _vm._l((_vm.found_optional_headers), function(item2) {
    return _c('option', {
      key: item2
    }, [_vm._v("\n              " + _vm._s(item2) + "\n              ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.unknown_headers.length))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', [_vm._v("Unknown Headers")]), _vm._v(" "), _c('td', [_c('select', {
    staticStyle: {
      "width": "150px"
    }
  }, _vm._l((_vm.unknown_headers), function(item3) {
    return _c('option', {
      key: item3
    }, [_vm._v(_vm._s(item3))])
  }))])]), _vm._v(" "), (this.missing_required_headers.length > 0) ? _c('tr', {
    staticStyle: {
      "color": "#770000"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.missing_required_headers.length))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('td', [_vm._v("Missing Headers")]), _vm._v(" "), _c('td', [_c('select', {
    staticStyle: {
      "width": "150px"
    }
  }, _vm._l((_vm.missing_required_headers), function(item4) {
    return _c('option', {
      key: item4
    }, [_vm._v(_vm._s(item4))])
  }))])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edit),
      expression: "!edit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background": "#FFFFFF",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "stitched"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$refs.upload && _vm.$refs.upload.dropActive),
      expression: "$refs.upload && $refs.upload.dropActive"
    }],
    staticClass: "drop-active"
  }, [_c('h3', [_vm._v("Drop files to upload")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text-center p-2"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "btn btn-primary",
    attrs: {
      "extensions": "csv,xls,xslx",
      "name": "locations",
      "drop": !_vm.edit
    },
    on: {
      "input-file": _vm.inputFile
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [_vm._v(_vm._s(_vm.uploadButtonDescription) + "\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "right",
      "background": "#FFFFFF",
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!this.canSaveFile) ? _c('button', {
    staticClass: "btn btn-outline-primary disabled",
    staticStyle: {
      "color": "#103E5A",
      "border-color": "#103E5A"
    }
  }, [_vm._v("Upload")]) : _vm._e(), _vm._v(" "), (this.canSaveFile) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.createNode
    }
  }, [_vm._v("Upload")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "25px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', {
    staticClass: "fa fa-exclamation"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-upload"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background": "#FFFFFF"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "src": "/static/img/baseline_cloud_upload_black_48dp.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Drag and Drop")]), _vm._v(" "), _c('p', [_vm._v("or")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dca02270"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/LocationUpload.vue
// module id = 570
// module chunks = 1